fx.translations("it",{
    "Sauvegarde de votre mise en page ..." : "Salvataggio del layout in corso...",

    "Les photos HEIC doivent être totalement téléchargées pour être utilisées pour la création automatique." : "Le immagini HEIC devono essere completamente scaricate per essere utilizzate nella creazione automatica."
});

